import { LeftOutlined } from "@ant-design/icons";
import { Collapse } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { selectOneSetting, selectViewMode } from "../../../../util/store/selectors";
import { VIEW_MODE } from "../../../../util/varibles/permission";
import { DashboardSetting } from "../../../../util/varibles/userSetting";
import { loginActions } from "../../../LoginPage/reducer";
import { EL_DASHBOARD } from "../constants";
import styles from '../style.module.scss';
import ActiveSite from "./ActiveSite";
import DiseasedZones from "./DiseasedZones";
import Factory from "./Factory";
import ProductionArea from "./ProductionArea";
import ProductionAreas from "./ProductionAreas";
import Toggle from "./Toggle";
import Vessel from "./Vessel";

const modeActive = new Set([VIEW_MODE.PLANNER, VIEW_MODE.SITE]);

interface IProps {
}

const RightControl: React.FC<IProps> = () => {
    const dispatch = useDispatch();
    const sectionFilter = useSelector(selectOneSetting(DashboardSetting.SECTION_FILTER))
    const viewMode = useSelector(selectViewMode)

    if (!modeActive.has(viewMode))
        return null;

    return <>
        <div id={EL_DASHBOARD.RIGHT_CONTROL} className={styles.controlRight}>
            <div className={styles.header}>
                <div data-lev='title'>Map Filter</div>
            </div>
            <div className={styles.body}>
                <Collapse
                    onChange={(value: any) => dispatch(loginActions.updateUserSetting([{ [DashboardSetting.SECTION_FILTER]: value }]))}
                    bordered={false}
                    defaultActiveKey={sectionFilter}
                    expandIconPlacement='end'
                    expandIcon={({ isActive }) => <LeftOutlined rotate={isActive ? -90 : 0} />}
                    items={[
                        {
                            key: 1,
                            className: styles.section,
                            label: viewMode === VIEW_MODE.PLANNER ? "Production areas, sites, factories" : "Production areas",
                            children: <>
                                <ProductionArea />
                                {viewMode === VIEW_MODE.PLANNER && <Factory />}
                                {viewMode === VIEW_MODE.PLANNER && <ActiveSite />}
                            </>
                        },
                        {
                            key: 2,
                            className: [styles.section, styles.grey].join(' '),
                            label: "Select site by production area",
                            children: <ProductionAreas />,
                        },
                        {
                            key: 3,
                            className: styles.section,
                            label: "Disease zones",
                            children: <DiseasedZones />,
                        },
                        {
                            key: 4,
                            className: [styles.section, styles.grey].join(' '),
                            label: "Vessels",
                            children: <Vessel />,
                        }
                    ]}
                />
            </div>
        </div>
        <Toggle />
    </>;
};

export default RightControl;
